import { render, staticRenderFns } from "./ClazzBtn.vue?vue&type=template&id=7504c6b4&scoped=true&"
import script from "./ClazzBtn.vue?vue&type=script&lang=js&"
export * from "./ClazzBtn.vue?vue&type=script&lang=js&"
import style0 from "./ClazzBtn.vue?vue&type=style&index=0&id=7504c6b4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7504c6b4",
  null
  
)

export default component.exports